exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tab-switcher[data-v-75a76c32] {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    overflow: hidden;\n.tabs[data-v-75a76c32] {\n        height: 100%;\n        overflow: hidden;\n.tab[data-v-75a76c32] {\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n            overflow: auto;\n            background: #fefefe;\n}\n}\n}\n", ""]);

// exports
